import { isSome, Maybe } from '@crocodille/util';
import { useTranslation } from 'react-i18next';

import styles from './opening-hours-table.module.scss';

export interface OpeningTime {
  readonly openFrom: Maybe<string>;
  readonly openTo: Maybe<string>;
}

const DAYS_OF_WEEK = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'] as const;
export type DayOfWeek = (typeof DAYS_OF_WEEK)[number];

export type OpeningTimes = Partial<Record<DayOfWeek, OpeningTime>>;

const OpeningHoursTable: React.FC<{ readonly openingHours: OpeningTimes }> = ({
  openingHours,
}) => {
  const { t } = useTranslation('restaurants');

  return (
    <table className={styles.container}>
      <tbody>
        {DAYS_OF_WEEK.map((day) => {
          const openingTime = openingHours[day];

          if (
            isSome(openingTime) &&
            isSome(openingTime.openFrom) &&
            isSome(openingTime.openTo)
          ) {
            return (
              <tr key={day}>
                <th className={styles.day}>{t(`weekday.${day}`)}</th>
                <td
                  className={styles.hours}
                >{`${openingTime.openFrom} - ${openingTime.openTo}`}</td>
              </tr>
            );
          } else {
            return (
              <tr key={day}>
                <th className={styles.day}>{t(`weekday.${day}`)}</th>
                <td className={styles.hours}>{t('branch.closed')}</td>
              </tr>
            );
          }
        })}
      </tbody>
    </table>
  );
};

export default OpeningHoursTable;
